import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionnaireKind, isTherapyMaterialKind } from '../../types/QuestionnaireKind';
import './ViewToggle.css';

type Props = {
    viewMode: 'questionnaires' | 'tasks';
    onViewModeChange: (mode: 'questionnaires' | 'tasks') => void;
    resourceKind: QuestionnaireKind;
};

const ViewToggle = ({ viewMode, onViewModeChange, resourceKind }: Props): JSX.Element => {
    const { t } = useTranslation();
    const isTherapyMaterial = isTherapyMaterialKind(resourceKind);

    return (
        <div className="frontpage__view-toggle">
            <button
                type="button"
                className={`frontpage__toggle-button ${viewMode === 'questionnaires' ? 'active' : ''}`}
                onClick={() => onViewModeChange('questionnaires')}
            >
                {isTherapyMaterial ? t('Available Therapy Material') : t('Available Questionnaires')}
            </button>
            <button
                type="button"
                className={`frontpage__toggle-button ${viewMode === 'tasks' ? 'active' : ''}`}
                onClick={() => onViewModeChange('tasks')}
            >
                {isTherapyMaterial ? t('Assigned Therapy Material') : t('Assigned Tasks')}
            </button>
        </div>
    );
};

export default ViewToggle;
